<template>
    <main class="single-event">
        <EventView />
    </main>
</template>

<script setup></script>
